module.exports = {"id":"208923","name":"Ibrahim Ghaleb","rating":"72","photo":"./data/images/photos/3/208923.png","club":{"name":"Al Nassr","logo":"./data/images/clubs/AlNassr.png"},"positions":["MDC","MC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/IbrahimGhaleb0.json
// module id = 1769
// module chunks = 0